<template>
    <div class="box">
        <div class="top-heig">运动计步</div>
        <div class="nameStyle">名称：{{ this.username }}</div>
        <div class="content-box">
            <div class="le-box" id="leBox">
                <div class="le-tu" id="LeTu"></div>
                <span class="title-text">今日步数</span>
                <span class="con-text"><span v-if="dataList.length">{{ dataList[0].stepNo }}</span>步</span>
                <span class="bot-text">行程: <span v-if="dataList.length">{{ dataList[0].kiloMetres }}</span>m</span>
            </div>
            <div class="rig-box">
                <div class="rig-tu" id="rigTu"></div>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import { exerciseCountStep } from '@/assets/api/zhongduan'
export default {
    components: {

    },
    data() {
        return {
            dataList: [],
            dataXXvalue: [],
            dataYYvalue: [],
            username:''
        };
    },
    created() {
        window.document.title = '运动计步'
        console.log(history.state,'当前item');
        this.username = history.state.deviceName
    },
    mounted() {
        this.exerciseCountStepGet()
        // this.huanxingtubiao()
    },
    methods: {
        exerciseCountStepGet () {
            let params = {
                imei: this.$route.query.iemi
            }
            exerciseCountStep(params).then((res)=> {
                console.log(res);
                let dataY = []
                let dataX = []
                res.data.data.forEach((item,index)=> {
                    console.log(item,index);
                    dataY.push(item.kiloMetres)
                    dataX.push(item.created.substring(0, 10))
                })
                this.dataList = res.data.data
                this.dataYYvalue = dataY
                this.dataXXvalue = dataX
                console.log(this.dataYYvalue,this.dataXXvalue);
                this.zhexiantubiao()
            }).catch((err)=> {
                console.log(err);
            })
        },
        zhexiantubiao () {
            let myChartZhe = echarts.init(document.getElementById('rigTu'));
            let option = {
                title: {
                    text: '一周内运动计步统计表',
                    x:'0%',      //可设定图例在左、右、居中
                    y:'10%',
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    // data: ['周一', '周二', '周三', '周四', '周五', '周六', 'Sun']
                    data: this.dataXXvalue
                },
                yAxis: {
                    show: true,    // 是否显示 y 轴
                    type: 'value',
                    boundaryGap: false,
                    // type: 'category', // Y轴类型为数值型
                    // axisLine: { onZero: true }
                    axisLine: {
                        lineStyle:{
                            color:'#000',// y轴的颜色
                            width:2,//y轴线的宽度
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                        color: 'rgba(204,204,204,0.30)',
                        type: 'solid'         
                            
                        }
                    },
                },
                legend: {
                    data: ['运动步数'],
                    x:'70%',      //可设定图例在左、右、居中
                    y:'10%',     //可设定图例在上、下、居中
                },
                grid: {
                    left: "10%",
                    right: "10%",
                    top: "30%",
                    bottom: "20%",
                },
                series: [
                    {
                    // data: [0, 100, 200, 534, 20, 1330, 1320],
                    data: this.dataYYvalue,
                    // data: [40,20],
                    name: '运动步数',
                    itemStyle: { color: '#1ECED0' } ,
                    type: 'line',
                    smooth: true
                    }
                ]
            };
            myChartZhe.setOption(option);
        },
        huanxingtubiao() {
            let myChart = echarts.init(document.getElementById('LeTu'));
            let option = {
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                // graphic: [{ //环形图中间添加文字
                //     type: 'text', //通过不同top值可以设置上下显示
                //     left: '45%',
                //     top: '60%',
                //     style: {
                //         text: '22 步',
                //         textAlign: 'center',
                //         fill: '#1E7CE8', //文字的颜色
                //         fontSize: 32,
                //         lineHeight: 16,
                //     }
                // },
                // { //环形图中间添加文字
                //     type: 'text', //通过不同top值可以设置上下显示
                //     left: '45%',
                //     top: '90%',
                //     style: {
                //         text: '行程：22m',
                //         textAlign: 'center',
                //         fill: '#1E7CE8', //文字的颜色
                //         fontSize: 32,
                //         lineHeight: 16,
                //     }
                // }],
                series: [

                    {
                        name: 'Access From',
                        type: 'pie',
                        radius: ['55%', '60%'],
                        labelLine: {
                            length: 30
                        },
                        // label: {
                        //   formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
                        //   backgroundColor: '#F6F8FC',
                        //   borderColor: '#8C8D8E',
                        //   borderWidth: 1,
                        //   borderRadius: 4,
                        //   rich: {
                        //     a: {
                        //       color: '#6E7079',
                        //       lineHeight: 22,
                        //       align: 'center'
                        //     },
                        //     hr: {
                        //       borderColor: '#8C8D8E',
                        //       width: '100%',
                        //       borderWidth: 1,
                        //       height: 0
                        //     },
                        //     b: {
                        //       color: '#4C5058',
                        //       fontSize: 14,
                        //       fontWeight: 'bold',
                        //       lineHeight: 33
                        //     },
                        //     per: {
                        //       color: '#fff',
                        //       backgroundColor: '#4C5058',
                        //       padding: [3, 4],
                        //       borderRadius: 4
                        //     }
                        //   }
                        // },
                        data: [
                            { value: 1048, itemStyle: { color: '#66FF99' } },
                            { value: 335, name: 'Direct', itemStyle: { color: 'red' } },

                        ]
                    }
                ]
            };
            myChart.setOption(option);

        }
    },
};
</script>

<style scoped lang="scss">
.box {
    height: 100vh;
    background-color: #fff;
    .top-heig {
        height: 75px;
        background-color: #2AC2EF;
        font-size: 50px;
        color: #fff;
        line-height: 75px;
        padding-left: 100px;
    }
    .nameStyle{
        font-size: 30px;
        padding-left: 100px;
        margin-top: 30px;
    }
    .content-box {
        width: 100%;
        // margin: 0 auto;
        position: relative;

        .le-box,
        .rig-box {
            // display: inline-block;
            position: absolute;
            top: 40px;
            width: 500px;
            height: 500px;
            // margin: 20px;
        }

        .le-box {
            left: 400px;
            .le-tu {
                width: 95%;
                height: 70%;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
                background-image: url(./img/huanxing.jpg);
                background-repeat: no-repeat;
                background-size: 100% 100%;
            }
            .title-text {
                position: absolute;
                left: 50%;
                top: 8%;
                transform: translate(-50%,0);
                font-size: 30px;
            }
            .con-text {
                position: absolute;
                left: 50%;
                top: 55%;
                transform: translate(-50%,0);
                font-size: 30px;
            }
            .bot-text {
                position: absolute;
                left: 45%;
                bottom: 15%;
                font-size: 30px;
            }
        }

        .rig-box {
            width: 600px;
            height: 500px;
            right: 300px;
            // border: 1px solid red;
            .rig-tu {
                width: 100%;
                height: 100%;
            }
        }
    }
}</style>
